<template>
  <div
    id="mmpSearchMenu"
    ref="mmpSearch"
    :class="[
      'wrap_search_ui',
      'active',
      isMobile ? 'mo':'pc' ,
      deviceType,
      isSticky ? 'sticky' : ''
    ]"
  >
    <div class="inner">
      <TotalSearchInput
        ref="refSearchInput"
        v-model="searchInput"
        :pre-page-search-keyword="preSearchKeyword"
        @search="performSearch"
        @autoCorsSearch="autoCorsSearch"
        @close="close"
      />
      <div :class="['result_inner']" >
        <TotalSearchRecent
          v-show="!isAutoCom"
          @onKeywordClick="onKeywordClick"
        />
        <TotalSearchRecommendedKeyword
          v-show="!isAutoCom"
          @onKeywordClick="onKeywordClick"
        />
        <TotalSearchAutoCors
          v-show="isAutoCom"
          ref="refAutoCors"
          :is-auto="isActiveAuto"
          @onKeywordClick="onKeywordClick"/>
      </div>
    </div>
  </div>
</template>

<script>
import TotalSearchInput from '~pages/nrw/search/TotalSearchInput'
import TotalSearchAutoCors from '~pages/nrw/search/TotalSearchAutoCors'
import TotalSearchRecent from '~pages/nrw/search/TotalSearchRecent'
import TotalSearchRecommendedKeyword from '~pages/nrw/search/TotalSearchRecommendedKeyword'
import moment from 'moment'

export default {
  name: 'TotalSearchMain',
  metaInfo () {
    return {
      title: '멀티캠퍼스 :: 통합검색'
    }
  },
  components: {
    TotalSearchInput,
    TotalSearchAutoCors,
    TotalSearchRecent,
    TotalSearchRecommendedKeyword
  },
  mixins: [],
  props: {
    // 검색결과 페이지 모드인지 여부 (검색결과 페이지에서만 값을 true 로 받아옴)
    searchResultMode: {
      type: Boolean,
      default: false
    },
    // 결과 페이지에서 입력한 검색어
    searchKeyword: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      searchInput: '',
      isDesktop: true,
      isSticky: false, // 페이지 스크롤 위치 기준 PC 검색 레이어의 상단 고정 여부를 판단하는 값 (true일때 상단 고정)
      scrollGap: 100, // 페이지 스크롤시 검색 레이어 위치 보정을 위한 스크롤 이동값
      preSearchKeyword: this.searchKeyword,
      beforeSearchMoveFlag: false // 검색 조회전 이벤트 처리 플래그 (true이면 이동, false면 이동 안함, 검색 레이어 닫기시 체크)
    }
  },
  computed: {
    isMobile () {
      return !window.vue.getStore('homeInfo').state.isDeskTopMode
    },
    deviceType () {
      return window.vue.getStore('homeInfo').state.deviceType
    },
    isAutoCom () { // 이전 검색이 있을 경우 자동완성은 생략
      return this.preSearchKeyword === '' && this.searchInput.trim().length > 0
    },

    isActiveAuto () { // 자동완성코스 검색 생략
      return this.preSearchKeyword !== this.searchInput
    }

  },
  watch: {
    // searchInput 값이 변경될 때마다 필요한 동작 수행
    searchInput (newVal) {
      if (newVal !== this.searchKeyword) {
        this.preSearchKeyword = '' // 결과 페이지 검색어 초기화
      }
    },
    isMobile (nVal) {
      if (nVal === true) {
        this.bodyScrollLock(true)
      } else {
        this.bodyScrollLock(false)
      }
    }
  },
  created () {
    // this.$mmpLoading = null
    this.$setNrwTotalSearchMain(this)
  },
  destroyed () {
    this.$setNrwTotalSearchMain(null)
  },
  mounted () {
    this.$nextTick(() => {
      this.setSearchEvt()
      this.addHeaderClass()
      // this.initSearch()
      // this.setDeviceType()
      // this.setInitSearchKeyword()
    })
  },
  beforeDestroy () {
    // this.$emit('close')
    this.removeHeaderClass()
    this.bodyScrollLock(false)
    this.removeSearchEvt()
  },
  methods: {
    // initSearch (fucusInput) {
    //    this.clearSearchKeyword(fucusInput)
    // },
    // 검색어 입력창 키워드 제거 및 인풋 포커스 처리
    // clearSearchKeyword (fucusInput) {
    //   const inp = this.$refs.mmpSearchInp
    //
    //   this.searchInput = ''
    //
    //   if (fucusInput === undefined || fucusInput === null) fucusInput = true
    //   if (fucusInput) inp.focus()
    // },
    /* setDeviceType () {
      const vw = window.innerWidth
      let isDesktop = true

      if (vw >= 1200) {
        this.deviceType = 'pc'
      } else {
        isDesktop = false

        if (vw <= 360) {
          this.deviceType = 'mobile'
        } else {
          this.deviceType = 'tablet'
        }
      }
      this.isDesktop = isDesktop
    }, */
    setSearchEvt () {
      window.addEventListener('scroll', this.chkScrollpos, true)
    },
    removeSearchEvt () {
      window.removeEventListener('scroll', this.chkScrollpos, true)
    },
    // 스크롤 위치가 상단에서 벗어났는지 확인 후 레이어 위치 보정
    chkScrollpos () {
      const gap = this.scrollGap
      const scrollPos = window.scrollY

      if (this.deviceType === 'pc') {
        if (scrollPos > gap) {
          this.isSticky = true
        } else {
          this.isSticky = false
        }
      }
    },
    // 페이지 스크롤 잠금, 잠금 해제
    bodyScrollLock (isLock) {
      setTimeout(function () {
        if (isLock) {
          document.body.classList.add('overflow')
        } else {
          document.body.classList.remove('overflow')
        }
      })
    },
    addHeaderClass () {
      const header = document.querySelector('.mmp_header')
      if (header) header.classList.add('has_search_ui')
    },
    removeHeaderClass () {
      const header = document.querySelector('.mmp_header')
      if (header) header.classList.remove('has_search_ui')
    },
    // 검색결과 페이지에서 검색어 값이 넘어온 경우 input value 에 설정
    setInitSearchKeyword () {
      if (this.searchKeyword !== '') {
        this.searchInput = this.searchKeyword
      }
    },
    // 카테고리 메뉴 닫기
    hideCategoryMenu () {
      const categoryMenu = document.querySelectorAll('.wrap_category_menu_expand')

      if (categoryMenu) {
        categoryMenu.forEach(element => element.classList.remove('active'))
      }
    },
    // 검색 레이어 닫기
    hideSearchLayer () {
      const searchLayer = document.querySelectorAll('#mmpSearchMenu')

      if (searchLayer) {
        searchLayer.forEach(element => element.classList.remove('active'))
      }
      this.removeHeaderClass()
    },
    performSearch (searchQuery) {
      this.beforeSearchMoveFlag = true
      const uuid = this.$utils.createUUID()
      this.$goPage({name: 'SearchCourseResult', params: {searchText: searchQuery, uuid}, query: {searchText: searchQuery, uuid}})

      this.$emit('onClickTotalSearch')
      this.isMobile && this.hideCategoryMenu() // 카테고리메뉴 닫음
      this.isMobile && this.hideSearchLayer() // 검색 레이어 닫기
      this.$emit('close') // 검색 레이어 닫기
    },
    autoCorsSearch (searchQuery) {
      this.searchInput = searchQuery
    },
    onKeywordClick (searchQuery) {
      this.searchInput = searchQuery
      this.setHistoryWord(searchQuery)
      this.performSearch(searchQuery)
    },

    setHistoryWord (searchQuery) {
      let val = searchQuery
      let text = []
      const recent = JSON.parse(window.localStorage.getItem('recent'))
      // localStorage 중복제거 및 저장
      if (recent) { // expireDate 확인
        if (moment(recent.expireDate).diff(moment()) < 0) {
          window.localStorage.removeItem('recent')
        } else {
          // 증복제거
          let removeIdx = recent.text.indexOf(val)
          if (removeIdx >= 0) {
            recent.text.splice(removeIdx, 1)
          }
          text = recent.text
        }
      }
      // recent 셋팅
      text.unshift(val)
      // 최대 6개
      if (text.length > 6) {
        text.splice(6)
      }
      // expireDate 셋팅
      const expireDate = moment().add(30, 'days')
      window.localStorage.setItem('recent', JSON.stringify({text: text, expireDate: expireDate}))
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/search/TotalSearchMain.vue